export const LISTAR = 'LISTAR'
export const LISTADO_SUCESSO = 'LISTADO_SUCESSO'

export const SELECIONAR = 'SELECIONAR'
export const SELECIONAR_RESET = 'SELECIONAR_RESET'

export const EXCLUIR = 'EXCLUIR'
export const EXCLUIR_PREPARAR = 'EXCLUIR_PREPARAR'
export const EXCLUIR_RESET = 'EXCLUIR_RESET'
export const EXCLUIR_SUCESSO = 'EXCLUIR_SUCESSO'